import gsap from 'gsap'
import SplitText from 'gsap/dist/SplitText'

import {
  getScrollTriggerTimelineOptions,
  getTimelineParallaxOptions
} from './shared'
import { Animation } from '@/types'

export const mediaParallaxAnimation = ({
  node,
  context,
  conditions,
  reverse
}: Animation) => {
  if (conditions?.isSmall) return

  const selector = context?.selector || gsap.utils.selector(node)

  /**
   * references
   */
  const media = selector('[data-motion-media]')
  const paragraph = selector('[data-motion-paragraph]')
  const splitParagraph = new SplitText(paragraph, { type: 'words' })

  const align =
    media[0]?.getAttribute('data-motion-align') ||
    paragraph[0]?.getAttribute('data-motion-align')

  /**
   * parallax animation
   */
  const parallax = gsap
    .timeline({ ...getTimelineParallaxOptions(node) })
    .fromTo(
      media,
      { xPercent: align === 'right' ? 50 : 0 },
      { xPercent: align === 'right' ? -150 : 0 }
    )
    .fromTo(
      paragraph,
      { xPercent: align === 'left' ? 20 : 0 },
      { xPercent: align === 'left' ? -60 : 0 },
      0
    )

  /**
   * reveal animation
   */
  const timeline = gsap
    .timeline({
      ...getScrollTriggerTimelineOptions(node, reverse),
      defaults: {
        ease: 'power1.out',
        duration: 1.4
      },
      onComplete: () => {
        if (reverse) return
        splitParagraph.revert()
      }
    })
    .from(splitParagraph.words, {
      opacity: 0.15,
      color: '#E5B273',
      stagger: { amount: 0.6 }
    })

  /**
   * revert
   */
  return () => {
    timeline?.kill()
    parallax?.kill()
    splitParagraph.revert()
  }
}
